import PropTypes from 'prop-types';

const ModalTopBar = ({ children = null }) => children;

ModalTopBar.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ModalTopBar;
